import Errors from './FormErrors';

class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data, filledFields = {}) {
        this.originalData = data || {};

        filledFields = filledFields || {};

        for (let field in data) {
            var prepopulatedValue = filledFields[field] !== undefined ? filledFields[field] : null;

            this[field] = data[field] || prepopulatedValue;
        }

        this.errors = new Errors();
    }


    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            this[field] = '';
        }

        this.errors.clear();
    }

    merge(newFields) {
        for (let field in newFields) {
            this[field] = newFields[field];
            this.originalData[field] = newFields[field];
        }
    }

    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     * @param multipart
     */
    post(url, multipart = false) {
        return multipart
            ? this.postMultipart(url)
            : this.submit('post', url);
    }


    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit('put', url);
    }


    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit('patch', url);
    }


    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit('delete', url);
    }


    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url) {
        return new Promise((resolve, reject) => {
            axios[requestType](url, this.data())
                .then(response => {
                    this.onSuccess(response.data);

                    resolve(response.data);
                })
                .catch(error => {
                    this.onFail(error.response.data.errors);

                    reject(error.response.data.errors);
                });
        });
    }

    postMultipart(url) {
        const data = new FormData();

        for (const [property, value] of Object.entries(this.data())) {
            data.append(property, value);
        }

        return new Promise((resolve, reject) => axios.post(url, data, {
                headers: {'content-type': 'multipart/form-data'}
            }).then(response => {
                this.onSuccess(response.data);
                resolve(response.data)
            }).catch((error) => {
                this.onFail(error.response.data.errors);
                reject(error.response.data.errors);
            })
        )
    }


    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {
    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        this.errors.record(errors);
    }
}

export default Form;



